import { MAX_VERSION_NAME_LENGTH } from "../constants/mappingVersion.constants";

export const normalizeVersionName = (name: string): string => name.trim().replace(/\s+/g, " ");

export const isVersionNameTaken = (name: string, existingVersionNames: string[]): boolean => {
  const normalized = normalizeVersionName(name).toLowerCase();
  return existingVersionNames.some(existing => normalizeVersionName(existing).toLowerCase() === normalized);
};

/**
 * react-hook-form `validate` contract: return `true` when valid, or the error message string.
 */
export const validateVersionName = (value: string, existingVersionNames: string[]): true | string => {
  const normalized = normalizeVersionName(value || "");

  if (!normalized) {
    return "Version name is required.";
  }

  if (normalized.length > MAX_VERSION_NAME_LENGTH) {
    return `Version name must be ${MAX_VERSION_NAME_LENGTH} characters or fewer.`;
  }

  if (isVersionNameTaken(normalized, existingVersionNames)) {
    return `A version named "${normalized}" already exists for this mapping. Please choose a different name.`;
  }

  return true;
};
